import React from "react";

// SVG imports (CRA / Vite supported)
import { ReactComponent as VideoIcon } from "../../assets/why/video-camera 1.svg";
import { ReactComponent as FileIcon } from "../../assets/why/file-minus-alt 1.svg";
import { ReactComponent as BookIcon } from "../../assets/why/book 1.svg";
import { ReactComponent as AnalyticsIcon } from "../../assets/why/Analytics.svg";

/*  Feature Card */
const FeatureCard = ({ title, desc, Icon }) => {
  return (
    <div
      className="
        flex-1
        bg-[linear-gradient(180deg,#36EDFA_0%,#2A5880_100%)]
        text-white
        py-6 px-6
        rounded-[8px]
        flex flex-col items-center text-center
       border border-[#248C9A]
        transform hover:-translate-y-2
        transition-transform duration-300
      "
    >
      {/* Icon */}
      <div className="w-14 h-14 bg-[#D6D1F5] rounded-full flex items-center justify-center mb-6">
        <Icon className="w-[24px] h-[24px] md:w-[24px] md:h-[24px] text-[#256FFA]" />
      </div>

      {/* Title */}
      <h3 className="text-[20px] md:text-[24px] font-[500] tracking-tight mb-4">
        {title}
      </h3>

      {/* Description */}
      <p className="text-[16px] leading-[20px] text-[#FFFFFFB2] tracking-[-0.5px] opacity-90 font-[500]">
        {desc}
      </p>
    </div>
  );
};

/*  Features Section  */
const Features = () => {
  return (
    <section
      className="
        w-full py-10 lg:py-28
        bg-[linear-gradient(77deg,#4096f68c,#e6394691)]
      "
    >
      <div className="container max-w-[1400px] mx-auto px-4 sm:px-6">
        {/* Heading */}
        <div className="text-center mb-13 md:mb-20">
          <h2
            className="
              text-[30px] sm:text-5xl md:text-[48px]
              font-medium
              bg-[linear-gradient(45deg,#6419CF,#256FFA)]
              bg-clip-text text-transparent
              tracking-tightest
              mb-5
            "
          >
            Why Choose BaapBola?
          </h2>

          <div className="w-28 h-1.5 bg-[#6A10CB] mx-auto mb-5"></div>

          <p className="text-[18px] text-white/90  mx-auto leading-relaxed tracking-tight">
            Our platform offers everything you need for successful exam
            preparation in one place
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          <FeatureCard
            title="Live Interactive Classes"
            desc="Learn from expert Zencators with live classes, doubt solving sessions, and real-time interaction."
            Icon={VideoIcon}
          />

          <FeatureCard
            title="Comprehensive Test Series"
            desc="Practice with thousands of mock tests, previous year papers, and topic-wise quizzes with detailed analysis."
            Icon={FileIcon}
          />

          <FeatureCard
            title="Smart Study Material"
            desc="Access well-structured notes, e-books, and practice questions curated by top Zencators."
            Icon={BookIcon}
          />

          <FeatureCard
            title="Performance Analytics"
            desc="Track your progress with detailed performance reports, strengths & weaknesses analysis, and improvement tips."
            Icon={AnalyticsIcon}
          />
        </div>
      </div>
    </section>
  );
};

export default Features;
